import { IonBackButton, IonButtons, IonCol, IonContent, IonGrid, IonPage, IonRow, IonTitle, isPlatform } from "@ionic/react";
import { useLiveQuery } from "dexie-react-hooks";
import { useEffect, useState } from "react";
import { RouteComponentProps } from "react-router";
import { CustomLoading, Header } from "../../components";
import { db } from "../../data/db/db";
import { ArticleCuttingParams } from "../../models/articleModel";
import { getAeMapping,  getMaterialGroups,  materialGroupsFormatting } from "./aeMapping";

import "./CuttingData.scss";
import { useTranslation } from "react-i18next";

interface CuttingDataProps extends RouteComponentProps<{
    ident: string,
    pos: string
}> { }

const CuttingData: React.FC<CuttingDataProps> = ({ match }) => {
    const ident = match.params.ident;
    const pos = match.params.pos;
    const [identState, setIdentState] = useState<string | null>();
    const [loading, setLoading] = useState<boolean>(false);
    const { t } = useTranslation();
    const aeMapping = getAeMapping(t);
    const materialGroups = getMaterialGroups(t);

    useEffect(() => {
        if (ident) {
            let str = ident.slice(0, 3) + " " + ident.slice(3, 5) + " " + ident.slice(5, 8)
            setIdentState(str.toUpperCase())
        }

        return () => {
            //unmount
            setIdentState(null);
        }
    }, [ident])

    const article: ArticleCuttingParams | undefined = useLiveQuery(
        async () => {
            if (identState && pos) {
                setLoading(true);
                const articles = await db.articlesCuttingParamsStd
                    .where({ ident: identState, pos: pos })
                    .first()
                setLoading(false)
                // Return result
                //console.log(articles)
                return articles;
            }

        },
        [identState, pos]
    );


    return (
        <IonPage>
            <Header>
                <IonButtons slot="start">
                    <IonBackButton defaultHref={"/tabs/calculator/preselection/sku1=" + ident} text={isPlatform('ios') ? t("Zurück") : undefined} />
                </IonButtons>
                <IonTitle>{t("Schnittwerte")}</IonTitle>
            </Header>
            <IonContent>
                <IonGrid fixed={true} className="mainContent">
                    <IonRow>
                        <IonCol size="12">
                            <div className="cuttingDataContainer">
                                {article && <div>
                                    <h2 className="cuttingDataTitle">{article.ident}-{article.pos}</h2>
                                    {Object.entries(article.data).map(([key, value]) => {
                                        return (
                                            <div key={key}>
                                                <div className="row">
                                                    <div className="leftMaterialCol" style={{ backgroundColor: `var(--mc-${key}-dark)` }}>{materialGroupsFormatting(key).toLocaleUpperCase()}<br /><span className="materialGroup">{materialGroups[key]}</span></div>
                                                    <div className="rightMaterialCol" style={{ backgroundColor: `var(--mc-${key}-light)` }}>
                                                        <table className="materialTable">
                                                            <tbody>
                                                                {Object.entries(value.vc).map(([vc_key, vc_val]) => {
                                                                    return (
                                                                        <tr key={vc_key} style={{ backgroundColor: `var(--mc-${key}-light)` }}>
                                                                            <td dangerouslySetInnerHTML={{ __html: vc_key }}></td>
                                                                            {/* @ts-ignore */}
                                                                            <td className="secondTableCol"><b>{vc_val}</b> m/min</td>
                                                                        </tr>
                                                                    )
                                                                })}
                                                                <tr style={{ backgroundColor: `var(--mc-${key}-hm)` }}>
                                                                    <td><b>hm</b></td>
                                                                    <td className="secondTableCol"><b>{parseFloat(value.fz.hm).toFixed(3)}</b> mm</td>
                                                                </tr>
                                                                <tr className="fz_row" style={{ backgroundColor: `var(--mc-${key}-fz)` }}>
                                                                    <td><b>a<sub>e</sub></b></td>
                                                                    <td className="secondTableCol">f<sub>z</sub> / a<sub>p</sub> &#091;mm&#093;</td>
                                                                </tr>
                                                                {Object.entries(value.fz).map(([fz_key, fz_val]) => {
                                                                    /* @ts-ignore */
                                                                    if (fz_key.startsWith("ae") && (parseFloat(fz_val[0]) !== 0 && parseFloat(fz_val[1]) !== 0)) {
                                                                        return (
                                                                            <tr key={fz_key} style={{ backgroundColor: `var(--mc-${key}-light)` }}>
                                                                                <td dangerouslySetInnerHTML={{ __html: aeMapping[fz_key] }}></td>
                                                                                {/* @ts-ignore */}
                                                                                <td className="secondTableCol"><b>{parseFloat(fz_val[0]).toFixed(3)}</b> / {parseFloat(fz_val[1]).toFixed(1)}</td>
                                                                            </tr>
                                                                        )
                                                                    } else { return null }
                                                                })}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>}

                                {!loading && !article && <p>{t("Wir haben leider keine Daten zu ... gefunden", { params: identState + "-" + pos })}</p>}
                            </div>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>
            <CustomLoading isOpen={loading} />
        </IonPage>
    )
}

export default CuttingData;